import React from 'react';
import cn from 'classnames';
import { TYPOGRAPHY_WEIGHT } from './constants';
import type { TypographyComponentProps, TypographyCompoundType } from './types';
import './style.scss';

export const Title1: React.FC<TypographyComponentProps> = ({
  children,
  className,
  weight,
  uppercase,
  ellipsis,
  ...props
}) => (
  <div className={cn('typography typography-h1', weight, { uppercase }, { ellipsis }, className)} {...props}>
    {children}
  </div>
);

export const Title2: React.FC<TypographyComponentProps> = ({
  children,
  className,
  weight,
  uppercase,
  ellipsis,
  ...props
}) => (
  <div className={cn('typography typography-h2', weight, { uppercase }, { ellipsis }, className)} {...props}>
    {children}
  </div>
);

export const Title3: React.FC<TypographyComponentProps> = ({
  children,
  className,
  weight,
  uppercase,
  ellipsis,
  ...props
}) => (
  <div className={cn('typography typography-h3', weight, { uppercase }, { ellipsis }, className)} {...props}>
    {children}
  </div>
);

export const Title4: React.FC<TypographyComponentProps> = ({
  children,
  className,
  weight,
  uppercase,
  ellipsis,
  ...props
}) => (
  <div className={cn('typography typography-h4', weight, { uppercase }, { ellipsis }, className)} {...props}>
    {children}
  </div>
);

export const Text: React.FC<TypographyComponentProps> = ({
  children,
  className,
  weight,
  uppercase,
  ellipsis,
  ...props
}) => (
  <div className={cn('typography typography-text', weight, { uppercase }, { ellipsis }, className)} {...props}>
    {children}
  </div>
);

export const Caption: React.FC<TypographyComponentProps> = ({
  children,
  className,
  weight,
  uppercase,
  ellipsis,
  ...props
}) => (
  <div className={cn('typography typography-caption', weight, { uppercase }, { ellipsis }, className)} {...props}>
    {children}
  </div>
);

export const Label: React.FC<TypographyComponentProps> = ({
  children,
  className,
  weight,
  uppercase,
  ellipsis,
  ...props
}) => (
  <div className={cn('typography typography-label', weight, { uppercase }, { ellipsis }, className)} {...props}>
    {children}
  </div>
);

export const NumbersLarge: React.FC<TypographyComponentProps> = ({
  children,
  className,
  weight,
  uppercase,
  ellipsis,
  ...props
}) => (
  <div className={cn('typography typography-numbers-large', weight, { uppercase }, { ellipsis }, className)} {...props}>
    {children}
  </div>
);

export const NumbersMedium: React.FC<TypographyComponentProps> = ({
  children,
  className,
  weight,
  uppercase,
  ellipsis,
  ...props
}) => (
  <div
    className={cn('typography typography-numbers-medium', weight, { uppercase }, { ellipsis }, className)}
    {...props}
  >
    {children}
  </div>
);

const TypographyComponent = (): React.ReactElement => <>Please, provide name component</>;

TypographyComponent.Title1 = Title1;
TypographyComponent.Title2 = Title2;
TypographyComponent.Title3 = Title3;
TypographyComponent.Title4 = Title4;
TypographyComponent.Text = Text;
TypographyComponent.Caption = Caption;
TypographyComponent.Label = Label;
TypographyComponent.NumbersLarge = NumbersLarge;
TypographyComponent.NumbersMedium = NumbersMedium;

export const Typography = TypographyComponent as TypographyCompoundType;
export { TYPOGRAPHY_WEIGHT };
